<template>
  <div class="common-page-outer loginOuter" id="loginPageOuter">
    <video autoplay width="100%" height="100%" muted loop>
      <source src="../../../../static/video/T.mp4" type="video/mp4" />
      浏览器不支持 video 标签，建议升级浏览器。
    </video>
    <div class="body-content">
      <div class="left-content">
        <img src="~@/assets/imagess/huzhoulogo.png" alt="" />
        <span class="small-title">丽企之家政务端平台</span>
      </div>
      <!-- 浙政钉登录 -->
      <div class="right-content" v-if="!zydd" style="height: 520px">
        <!-- <div class="zzd-nav" @click="otherZydd(1)">
          <i class="el-icon-arrow-left"></i> 返回
        </div> -->
        <img
          src="../../../../static/images/qrcode.png"
          class="qr-image"
          @click="otherZydd(1)"
        />
        <iframe
          v-if="fillIn"
          style="display: block; padding-top: 50px; margin: 0 auto"
          :src="scanUrl"
          frameborder="none"
          id="autoLoginFrame"
          height="80%"
          width="90%"
        ></iframe>
        <div class="information" v-if="!fillIn">
          <b>填写信息</b>
          <div class="notes">
            当前账号未注册，请填写个人信息方便管理员审核。
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="用户名：" prop="userName">
              <el-input
                v-model="ruleForm.userName"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="mobile">
              <el-input
                v-model="ruleForm.mobile"
                placeholder="请输入手机号"
                autocomplete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input
                type="password"
                v-model="ruleForm.password"
                autocomplete="new-password"
                placeholder="密码8-16位，由大小写字母、数字、特殊字符组成"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="newpassword">
              <el-input
                type="password"
                v-model="ruleForm.newpassword"
                placeholder="重复输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div
        class="right-content"
        v-if="zydd"
        :style="isenterprise ? 'height: 520px' : 'height: 420px'"
      >
        <img
          src="../../../../static/images/qrcode.png"
          class="qr-image"
          @click="otherZydd(0)"
        />
        <div class="government">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="index === navIndex ? 'active' : ''"
            @click="enterpriseNav(index)"
            class="government-item"
          >
            {{ item }}
          </div>
        </div>
        <!-- 账号密码登录 -->
        <div class="login" v-if="!isenterprise">
          <!-- <div class="login-title">
            <div class="logo logo_js">欢迎登录</div>
          </div> -->
          <div class="login-body">
            <div class="login-input">
              <div class="left">
                <i class="el-icon-user"></i>
                用户名
              </div>
              <input
                class="user"
                v-model="loginForm.username"
                type="text"
                name="username"
                placeholder="请输入用户名(账号)"
              />
            </div>
            <div class="login-input">
              <div class="left">
                <i class="el-icon-lock"></i>
                密码
              </div>
              <input
                class="password"
                type="password"
                v-model="loginForm.password"
                name="password"
                @keyup.enter="submitBtn"
                placeholder="请输入密码"
              />
            </div>
            <div class="login-input">
              <div class="left">
                <i class="iconfont">&#xe76c;</i>
                验证码
              </div>
              <input
                class="user"
                v-model="loginForm.verifyCode"
                maxlength="4"
                type="text"
                name="verifyCode"
                placeholder="请输入验证码"
                style="width: 130px"
              />

              <!-- <div class="verificationCode" @click="createCode()">
                {{ verification }}
              </div> -->
              <img
                class="verificationCode"
                :src="`data:image/gif;base64,${this.verification}`"
                @click="createCode()"
              />
            </div>
          </div>
          <div class="login-foot">
            <div class="submit-btn" @click="submitBtn">登录</div>
            <div class="handel-pass">
              <div class="remember">
                <el-checkbox v-model="isCheck">
                  <span class="fff">记住密码</span>
                </el-checkbox>
              </div>
            </div>
          </div>
          <!-- <div class="login-footer">
            <div class="other">其他方式登录</div>
            <i @click="otherZydd(0)"></i>
          </div> -->
        </div>
        <!-- 企业扫码登录 -->
        <div class="enterprise" v-if="isenterprise">
          <b> 丽企之家登录</b>
          <div>打开丽企之家，扫一扫二维码登录</div>
          <div id="qrcode" ref="qrcode"></div>
          <div @click="getScanQrcode" class="refresh">
            <i class="el-icon-refresh"></i>刷新
          </div>
          <div class="code-expired" v-if="isTrue">
            <div>您的二维码已失效<br />请点击下方刷新按钮</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dd from 'gdt-jsapi'
import { notEmpty, isPhone, onlyNumEng } from '@utils'
import { Base64 } from 'js-base64'
import md5 from 'js-md5'
import QRCode from 'qrcodejs2'
import { getLoadImgCode, loginFailedExecute } from '@api/commonApi'

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (value.length < 8) {
          callback(new Error('密码不能少于8位，请您重新输入'))
        }
        if (value.length > 16) {
          callback(new Error('密码最大长度为16位，请您重新输入'))
        }
        let reg = /^(?=.*[a-zA-Z])(?=.*[\d])[\w\W]{6,16}$/
        if (!reg.test(value)) {
          callback(new Error('密码8-16位，由大小写字母、数字、特殊字符组成'))
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    // var checkAge = (rule, value, callback) => {
    //   if (value !== this.verification) {
    //     this.createCode()
    //     // this.form.verifyCode = '';
    //     return callback(new Error('验证码错误,请重新输入'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loginForm: {
        username: '',
        password: '',
        source: 1,
        verifyCode: ''
      },
      ruleForm: {
        userName: '',
        name: '',
        mobile: '',
        password: '',
        userData: '',
        newpassword: ''
      },
      verification: '',
      uuid: '',
      rules: {
        userName: [notEmpty('用户名'), onlyNumEng('用户名')],
        name: [notEmpty('姓名')],
        mobile: [notEmpty('正确的手机号'), isPhone('手机号')],
        password: [
          notEmpty('密码'),
          { validator: validatePass, trigger: 'blur' }
        ],
        newpassword: [
          notEmpty('密码'),
          { validator: validatePass2, trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
          // { validator: checkAge, trigger: 'blur' }
        ]
      },
      isCheck: false,
      zydd: true,
      fillIn: true,
      isenterprise: false,
      isTrue: false,
      ticket: '',
      qr: '',
      settime: '',
      navList: ['政务用户', '企业用户'],
      navIndex: 0,
      scanUrl1:
        'https://login-pro.ding.zj.gov.cn/qrlogin/webAppLogin.htm?APP_NAME=ls_scan_qymdingoa_dingoa&protocolKey=ls_scan_qymdingoa_dingoa-C278L6hAEOKVMmz65MwoW02D0vDJ5Ymt9MnmAFn&protocol=oauth2&BACK_URL=http://lsqym-pc.yscredit.com/gov.html&embedMode=true&scope=get_user_info&state=',
      scanUrl2:
        'https://login.dg-work.cn/qrlogin/webAppLogin.htm?APP_NAME=ls_scan_qym_dingoa&protocolKey=75d6d8ac-1938-4081-a36f-a4ef04da9577&protocol=oauth2&BACK_URL=http://10.1.1.124:8827/gov.html&embedMode=true&scope=get_user_info&state=',
      scanUrl:
        // 'https://login-pro.ding.zj.gov.cn/qrlogin/webAppLogin.htm?APP_NAME=ls_scan_qymdingoa_dingoa&protocolKey=ls_scan_qymdingoa_dingoa-C278L6hAEOKVMmz65MwoW02D0vDJ5Ymt9MnmAFn&protocol=oauth2&BACK_URL=http://lsqym-pc.yscredit.com/gov.html&embedMode=true&scope=get_user_info&state=' // 浙政钉
        'https://login.dg-work.cn/qrlogin/webAppLogin.htm?APP_NAME=ls_scan_qym_dingoa&protocolKey=75d6d8ac-1938-4081-a36f-a4ef04da9577&protocol=oauth2&BACK_URL=http://10.1.1.124:8827/gov.html&embedMode=true&scope=get_user_info&state=' // 专有钉钉
    }
  },
  created() {
    this.getCookie()
    this.createCode()
    window.location.href.includes('8827')
    process.env.NODE_ENV == 'development'
      ? (this.scanUrl = this.scanUrl2)
      : window.location.href.includes('8827')
      ? (this.scanUrl = this.scanUrl2)
      : (this.scanUrl = this.scanUrl1)
  },
  mounted() {
    const that = this
    // this.submitBtn()
    window.onmessage = function(event) {
      that.getQRCode(event)
    }
    // window.addEventListener('message', this.getQRCode)
  },
  methods: {
    createCode() {
      getLoadImgCode().then(res => {
        this.uuid = res.data.uuid
        this.verification = res.data.code
      })
    },
    // 生成二维码
    qrcode(code) {
      this.qr = new QRCode('qrcode', {
        width: 250, // 二维码宽度，单位像素
        height: 250, // 二维码高度，单位像素
        text: code // 生成二维码的链接
      })
    },
    getScanQrcode() {
      this.$store
        .dispatch('user/getScanQrcode')
        .then(resData => {
          this.$nextTick(() => {
            if (this.qr) {
              this.isTrue = false
              this.qr.clear() // 清除代码
              this.qr.makeCode(resData.data.qrcode) // 生成另外一个二维码
            } else {
              this.qrcode(resData.data.qrcode)
            }
          })
          this.ticket = resData.data.ticket
          this.checkScanStatus()
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkScanStatus(ticket) {
      const self = this
      this.$store
        .dispatch('user/checkScanStatus', { ticket: this.ticket })
        .then(res => {
          if (res.status == '00') {
            clearInterval(this.settime)
            this.isTrue = true
            this.$router.push({
              path: this.redirect || '/',
              query: this.otherQuery
            })
            this.loading = false
          }
          if (res.status == '05') {
            this.entName = res.entName
            this.settime = setTimeout(function() {
              self.checkScanStatus()
            }, 1000)
          }
          if (res.status == '01') {
            this.isTrue = true
          }
          if (res.status == '02') {
            this.settime = setTimeout(function() {
              self.checkScanStatus()
            }, 1000)
          }
          if (res.status == '06') {
            this.entName = res.message
          }
          if (res.status == '08' || res.status == '06') {
            this.$message({
              message: res.message,
              type: 'warning'
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getQRCode(event) {
      const code = event.data.code
      if (code) {
        this.$store
          .dispatch('user/autoLogin', { code: code })
          .then(resData => {
            const { data, code } = resData
            if (code === '050002') {
              this.fillIn = false
              this.ruleForm.name = data.lastName
              this.ruleForm.userData = JSON.stringify(data)
            } else {
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery
              })
              this.loading = false
            }
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    enterpriseNav(index) {
      this.navIndex = index
      if (index === 0) {
        document.getElementById('qrcode').innerHTML = ''
        this.qr.clear()
        this.qr = ''
        this.isenterprise = false
        clearInterval(this.settime)
      } else {
        this.isenterprise = true
        this.getScanQrcode()
      }
    },
    otherZydd(index) {
      if (index === 0) {
        this.zydd = false
      } else {
        this.zydd = true
        this.fillIn = true
      }
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = {
            userName: this.ruleForm.userName,
            name: this.ruleForm.name,
            mobile: this.ruleForm.mobile,
            password: md5(this.ruleForm.password),
            userData: this.ruleForm.userData
          }

          this.$store
            .dispatch('user/loginAndBind', params)
            .then(res => {
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery
              })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitBtn() {
      if (this.loginForm.userName == '') {
        this.$message('登录名不能为空')
        return
      } else if (this.loginForm.password == '') {
        this.$message('密码不能为空')
        return
      } else if (this.loginForm.verifyCode === '') {
        this.$message('请输入验证码')
        return
      }
      // } else if (this.loginForm.verifyCode !== this.verification) {
      //   this.$message('验证码错误,请重新输入')
      //   this.createCode()
      //   return
      // }
      const self = this
      if (self.isCheck == true) {
        var password = Base64.encode(self.loginForm.password)
        self.setCookie(self.loginForm.username, password, 7)
      } else {
        self.clearCookie()
      }
      var loginData = {
        username: `${this.loginForm.username}-${this.uuid}-${this.loginForm.verifyCode}`,
        password: this.loginForm.password,
        source: 1,
        verifyCode: this.loginForm.verifyCode
      }

      this.$store
        .dispatch('user/login', loginData)
        .then(() => {
          this.$router.push({
            path: this.redirect || '/',
            query: this.otherQuery
          })
          this.loading = false
        })
        .catch(err => {
          if (err.data.data == '密码错误') {
            loginFailedExecute({ username: this.loginForm.username }).then(
              res => {
                this.$message.error(`${res.data.data}`)
              }
            )
          }
          this.createCode()
          this.loading = false
        })
    },
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date()
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
      window.document.cookie =
        'username' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'password' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
    },
    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ')
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=')
          if (arr2[0] == 'username') {
            this.loginForm.username = arr2[1]
          } else if (arr2[0] == 'password') {
            this.loginForm.password = Base64.decode(arr2[1])
          }
        }
      }
      if (this.loginForm.username && this.loginForm.password) {
        this.isCheck = true
      }
    },
    clearCookie() {
      this.setCookie('', '', -1)
    }
  }
}
</script>
<style lang="scss" scoped>
#loginPageOuter {
  // background: url('~@/assets/imagess/huzhoubeijing.jpg') no-repeat;
  // background-size: cover;
  /* background-image: linear-gradient(to right, #244b8d, #072446, #061c40); */
  // display: flex;
  // align-items: center;
  height: 100%;
  overflow: hidden;
  background-color: rgba(6, 20, 55, 0.5);
  video {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    object-fit: fill;
    source {
      width: 100%;
      height: 100%;
    }
  }
  .body-content {
    position: relative;
    margin: 240px auto;
    width: 1139px;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left-content {
      margin-top: 50px;
      height: 400px;
      color: #ffffff;
      text-align: justify;
      text-align-last: justify;
      .small-title {
        height: 40px;
        line-height: 40px;
        font-size: 36px;
        padding-left: 40px;
        vertical-align: 50%;
      }
      .title {
        height: 84px;
        line-height: 84px;
        font-size: 54px;
      }
      .intro {
        display: flex;
        justify-content: space-between;
        height: 20px;
        line-height: 20px;
        font-size: 20px;
        letter-spacing: 1.25px;
      }
      .pc {
        margin: 0 auto;
        margin-top: 40px;
        width: 330px;
        height: 218px;
        // background: url('../../../assets/imagess/pc.png') no-repeat center/cover;
      }
    }
    .right-content {
      width: 420px;
      height: 420px;
      border-radius: 4px;
      background: #fff;
      padding: 0 0 25px;
      position: relative;
      .government {
        width: 100%;
        display: flex;
        padding: 28px;
        .government-item {
          font-size: 18px;
          margin-right: 24px;
          height: 30px;
          line-height: 20px;
          color: rgba(0, 0, 0, 0.85);
          opacity: 0.5;
          font-weight: 550;
          cursor: pointer;
          position: relative;
        }
        .active {
          // border-bottom: 3px solid #409eff;
          font-weight: 550;
          opacity: 1;
        }
        .active:before {
          content: '';
          position: absolute;
          left: 16px;
          top: auto;
          bottom: 0;
          right: auto;
          height: 3px;
          width: 50%;
          background-color: #008bff;
        }
      }
      .login {
        height: 450px;
        border-radius: 4px;
        padding: 0 28px;
        &-body {
          display: flex;
          flex-direction: column;
          // align-items: center;
          position: relative;
          .login-input {
            display: flex;
            width: 100%;
            height: 42px;
            margin-bottom: 24px;
            border-radius: 2px;
            background-color: rgba(227, 234, 239, 0.15);
            border: 1px solid rgba(229, 229, 229, 1);
            .left {
              width: 100px;
              padding: 12px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
            }
            input {
              flex: 1;
              background: transparent;
              border: none;
              outline: none;
              text-indent: 11px;
              // color: #fff;
              &::-webkit-input-placeholder {
                /* WebKit browsers */
                color: rgba(255, 255, 255, 0.5);
                font-size: 12px;
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(255, 255, 255, 0.5);
                font-size: 12px;
              }
              &::-ms-input-placeholder {
                /* Internet Explorer 10+ */
                color: rgba(255, 255, 255, 0.5);
                font-size: 12px;
              }
            }
            &:nth-child(3) {
              width: 70%;
            }
            .verificationCode {
              position: absolute;
              right: 0;
              width: 85px;
              height: 40px;
              font-size: 18px;
              line-height: 40px;
              text-align: center;
              letter-spacing: 4px;
              cursor: pointer;
              background-color: rgba(246, 248, 255, 1);
              border-radius: 2px;
            }
          }
          .login-code {
            display: flex;
            width: 200px;
            height: 42px;
            border-radius: 2px;
            background-color: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.5);
            input {
              width: 150px;
            }
          }
          .tip {
            color: #fff;
            width: 390px;
            font-size: 14px;
            margin: 20px auto 0;
            span {
              text-decoration: underline;
            }
          }
        }
      }
      .login-foot {
        margin-top: 16px;
        .handel-pass {
          margin: 12px 0 30px;
          width: 320px;
          display: flex;
          justify-content: space-between;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          .remember {
            cursor: pointer;
            display: flex;
            align-items: center;
            /deep/.el-checkbox {
              .el-checkbox__label {
                color: rgba(0, 0, 0, 0.8);
              }
            }
            /deep/.el-checkbox__inner {
              width: 14px;
              height: 14px;
            }
            /deep/.is-checked {
              .el-checkbox__label {
                color: #409eff;
              }
            }
          }
          .forget {
            cursor: pointer;
          }
          input {
            cursor: pointer;
            -webkit-appearance: none; //这个属性是将input标签变成一个可修改样式的普通标签，目前有谷歌和火狐浏览器支持
            -moz-appearance: none;
            width: 12px;
            height: 12px;
            margin: 0px;
            margin-right: 10px;
            background-color: transparent;
            border: 1px solid rgba(255, 255, 255, 0.5);
            outline: none;
          }
        }
        .submit-btn {
          width: 100%;
          height: 44px;
          line-height: 44px;
          border-radius: 2px;
          // opacity: 1;
          background: linear-gradient(to right, #00b9fd, #008bff);
          // background-color: rgba(255, 255, 255, 0.2);
          color: white;
          font-size: 16px;
          text-align: center;
          cursor: pointer;
        }
      }
      .zzd-nav {
        width: 80px;
        margin: 20px 0 0 10px;
        cursor: pointer;
      }
      .zzd-url {
        width: 200px;
        height: 200px;
      }
      .information {
        margin-top: 30px;
        text-align: center;
        b {
          font-size: 20px;
        }
        .notes {
          margin: 10px auto;
          color: #999;
        }
        .el-form-item {
          width: 350px;
          margin-left: 20px;
        }
        .el-button--medium {
          width: 90%;
          margin-top: 20px;
        }
      }
      .enterprise {
        position: relative;
        padding-top: 30px;
        text-align: center;
        font-size: 18px;
        b {
          display: inline-block;
          margin-bottom: 16px;
        }
        #qrcode {
          width: 250px;
          height: 250px;
          margin: 20px auto;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100% !important;
            height: 100% !important;
          }
        }

        .refresh {
          cursor: pointer;
        }
        .code-expired {
          position: absolute;
          z-index: 10;
          left: 69px;
          top: 96px;
          width: 285px;
          height: 269px;
          background-color: hsla(0, 0%, 93.7%, 0.9);
          text-align: center;
          border: 1px solid #efefef;
          line-height: 26px;
          color: rgba(10, 36, 99, 0.45);
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .qr-image {
        width: 68px;
        height: 70px;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
      }
    }
  }
}
.el-checkbox__label {
  color: hsla(0, 0%, 100%, 0.5);
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: hsla(0, 0%, 100%, 0.5);
}
</style>
